module.exports = __webpack_public_path__ + "static/media/about_part1.2cdc5d91.png";